<div class="container-box">
  <app-table-header
    tableTitle="Cross F8"
    (btnUpdateClick)="reloadTrigger$.next()"
  ></app-table-header>
  <div class="table-container">
    <app-new-table
      [dataSource]="dataSource"
      [reloadTrigger$]="reloadTrigger$"
      [displayedColumns]="displayedColumns"
      [initialSort]="{
        active: 'practiceNumber',
        direction: 'desc'
      }"
    ></app-new-table>
  </div>
</div>
